import React from 'react';
import loadable from '@loadable/component';

import { bool, object } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { camelize } from '../../util/string';
import { propTypes } from '../../util/types';

import FallbackPage from './FallbackPage';
import { ASSET_NAME } from './LandingPage.duck';

import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';
import FooterContainer from '../../containers/FooterContainer/FooterContainer';
import logoImage from '../../assets/images/Logo.png';
import cardImg1 from '../../assets/images/card1.jpg';
import cardImg2 from '../../assets/images/card2.jpg';
import cardImg3 from '../../assets/images/card3.jpg';
import farmerImg from '../../assets/images/farmer.jpeg';
import leafImg from '../../assets/images/leaf.png';
import coopImage from '../../assets/images/sellfresh.png';
import basketImage from '../../assets/images/discover.png';
import paymentImage from '../../assets/images/card3.jpg';

import { NamedLink } from '../../components';
import SpringPicksSection from "../../components/SpringPicksSection/SpringPicksSection";

import css from './LandingPage.module.css'
import { FaInstagram, FaFacebookF, FaTiktok, FaShoppingCart } from 'react-icons/fa';
import farmerFeatured from "../../assets/images/farmer.png";

const PageBuilder = loadable(() =>
  import(/* webpackChunkName: "PageBuilder" */ '../PageBuilder/PageBuilder')
);

export const LandingPageComponent = props => {
  const { pageAssetsData, inProgress, error, currentUser } = props;

  return (
    <div 
      className={css.landingPageNew}
      style={{
        backgroundImage: `url(${require('../../assets/images/woodBg.jpg')})`,
      }}
    >
      <TopbarContainer />

      {/* Hero Section */}
      <section 
        className={css.heroSection} 
        style={{
          backgroundImage: `url(${require('../../assets/images/newHero.png')})`,
        }}
      >
        <div className={css.heroContainer}>
          {/*<img src={logoImage} alt="Farmiez Logo" className={css.heroLogo} />*/}
          <h1 className={css.heroTitle}>
            Buy & Sell Fresh, Local Food
          </h1>
          <p className={css.heroSubtitle}>
            Connecting Growers & Communities
          </p>

          <NamedLink name="SearchPage" className={css.customBtn}>Browse Fresh Picks</NamedLink>

          {currentUser?.id ? (
            <NamedLink name="NewListingPage" className={css.customBtnOutline}>Start Selling</NamedLink>
          ) : (
            <NamedLink name="SignupPage" className={css.customBtnOutline}>Start Selling</NamedLink>
          )}

          {/*<NamedLink name="SignupPage" className={css.customBtn}>🥚 Shop Farmiez Now</NamedLink>
          <p className={css.btnUnderText}>🛒 Shopping on Farmiez is always free — no fees, ever.</p>
          <p className={css.btnUnderText}>
            🐓 Farmers keep 100% of what they earn, with 5 Fresh Picks every month on the free plan.
          </p>*/}
        </div>
      </section>

      {/* Featured Farmer */}
      <div className={css.featuredWrapper}>
        <div className={css.featuredWrapperInner}>
          <div className={css.featuredComingSoon}>
            <div className={css.featureDetailsBox}>
              <h2 className={css.title}>
                <img src={leafImg} alt="img" />
                <span>FEATURED FARMER</span>
              </h2>
              <p className={css.description}>
                <strong>Hi, I'm Jeff,</strong> a backyard chicken keeper here in Chesapeake with a
                flock of about 30 hens raised on our open backyard farm. I started
                keeping chickens to provide fresh eggs I could trust and to stay
                connected to where my food comes from. I'm proud to share clean,
                locally raised eggs with neighbors across our community.
              </p>
              <ul className={css.features}>
                <li>Pickup in Chesapeake</li>
                <li>Fresh eggs available weekly</li>
                <li>Fast response to orders</li>
                <li>Secure checkout via Farmiez</li>
              </ul>
              <a href="https://www.farmiezmarketplace.com/u/693dab60-196a-4403-b5ed-6c954bd0dcf1" className={css.customBtn}>
                Shop This Farm
              </a>
            </div>

            <div className={css.farmerImgBox}>
              <div className={css.imageWrapper}>
                <img src={farmerFeatured} alt="img" />
              </div>
              <h3 className={css.farmerName}>JEFF BEARD</h3>
              <p className={css.farmerTitle}>Backyard Chicken Keeper</p>
            </div>
          </div>

          <SpringPicksSection />
        </div>
      </div>

      {/* How It Works */}
      <section 
        className={css.howItWorksSection} 
        >
        <div className={css.howItWorksContainer}>
          <h2 className={css.sectionTitle}>How Farmiez Marketplace Works</h2>
          <div className={css.cardsContainer}>
            <div className={css.card}>
              <div className={css.cardImgBox}>
                <img src={coopImage} alt="Farmiez Farmer" className={css.cardImage} />
              </div>
              <h3 className={css.cardTitle}>Farmiez Farmer</h3>
              {currentUser?.id ? (
                <NamedLink name="NewListingPage" className={css.coopButton}>
                  {/*<span>🐓</span> 
                  <span>Join the Coop</span>*/}
                  Start Selling
                </NamedLink>
              ) : (
                <NamedLink name="SignupPage" className={css.coopButton}>
                  {/*<span>🐓</span> 
                  <span>Join the Coop</span>*/}
                  Start Selling
                </NamedLink>
              )}
            </div>
            <div className={css.card}>
              <div className={css.cardImgBox}>
                <img src={paymentImage} alt="Farmiez Farmer" className={css.cardImage} />
              </div>
              <h3 className={css.cardTitle}>Farmiez Shopper</h3>
              <NamedLink name="SearchPage" className={css.coopButton}>
                {/*<span>🥚</span> 
                <span>Shop Farmiez Now</span>*/}
                Browse Fresh Picks
              </NamedLink>
            </div>
            {/*<div className={css.card}>
              <div className={css.cardImgBox}>
                <img src={cardImg3} alt="Farmiez Farmer" className={css.cardImage} />
              </div>
              <h3 className={css.cardTitle}>Getting Paid</h3>
              <NamedLink name="GettingPaidPage" className={css.coopButton}>
                <span>🐓</span> 
                <span>Getting Paid with Farmiez</span>
              </NamedLink>
            </div>*/}
          </div>
        </div>
      </section>

      {/*<section className={css.featuredFarmerSection}s>
        <h2 className={css.sectionTitleGreen}>Featured Farmiez Farmer</h2>
        <div className={css.farmerContainer}>
          <div className={css.farmerImgBox}>
            <img
              src={farmerImg}
              alt="Alex Barnett"
              className={css.farmerImage}
            />
            <div className={css.farmerDetails}>
              <div className={css.userBox}>
                <h3 className={css.farmerName}>Alex Barnett</h3>
                <div className={css.farmerLocation}>Chesapeake, VA</div>
              </div>
              <a href="/s" className={css.shopButton}>
                <span>🥚</span>
                <span>Shop Farmiez Now</span>
                <FaShoppingCart className={css.cartIcon} />
              </a>
            </div>
          </div>
          <div className={css.devider}></div>
          <div className={css.farmerText}>
            <p className={css.farmerBio}>
              Featured Farmer Coming Soon
            </p>
          </div>
        </div>
      </section>*/}


      {/* Getting Paid Teaser Section */}
      {/*<section className={css.gettingPaidTeaser}>
        <div className={css.teaserContent}>
          <h2 className={css.heading}>Getting Paid is Simple 🐓💰</h2>
          <p>Farmiez uses <strong>Stripe</strong> for secure payments and fast payouts—typically in your bank within <strong>2–3 business days</strong> after an order is complete.</p>
          <a href="/getting-paid" className={css.customBtn}>
            Learn More ➜
          </a>
        </div>
      </section>*/}

      {/* stay Connected Section */}
      <section 
        className={css.stayConnectedSection} 
        // style={{
        //   backgroundImage: `url(${require('../../assets/images/woodBg.jpg')})`,
        // }}
        >
        <div className={css.stayConnectedContainer}>
          <div className={css.stayConnectedBox}>
            <div className={css.iconWrapper}>
              <span className={css.linkIcon}>🔗</span>
            </div>
            <h2 className={css.connectTitle}>Stay Connected</h2>
            <div className={css.socialIcons}>
              <FaInstagram className={css.socialIcon} />
              <FaFacebookF className={css.socialIcon} />
              <FaTiktok className={css.socialIcon} />
            </div>
            <p className={css.handle}>@FarmiezMarket</p>
          </div>
        </div>
      </section>
      
      <FooterContainer />
    </div>
  );
};

LandingPageComponent.propTypes = {
  pageAssetsData: object,
  inProgress: bool,
  error: propTypes.error,
};

const mapStateToProps = state => {
  const { currentUser } = state.user;
  const { pageAssetsData, inProgress, error } = state.hostedAssets || {};
  return { pageAssetsData, inProgress, error, currentUser };
};

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const LandingPage = compose(connect(mapStateToProps))(LandingPageComponent);

export default LandingPage;
